import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import React from 'react';
import MenuColumn from './MenuColumn';

const PREFIX = 'HorizontalMenu';

const classes = {
  icon: `${PREFIX}-icon`,
  drawerList: `${PREFIX}-drawerList`,
  toolbar: `${PREFIX}-toolbar`,
  columnContainer: `${PREFIX}-columnContainer`,
  drawer: `${PREFIX}-drawer`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.icon}`]: { color: theme.palette.primary.contrastText },
  [`& .${classes.drawerList}`]: {},
  [`& .${classes.toolbar}`]: {},

  [`& .${classes.columnContainer}`]: {
    display: 'flex',
    height: 'calc(100% - 64px)'
  },

  [`& .${classes.drawer}`]: {}
}));

interface Data {
  _id: string;
  title: string;
  enabled: boolean;
  description?: string;
  group?: string | null;
  link: string;
  icon?: string | JSX.Element;
  children: Data[];
  rangecolor?: string;
}

interface HorizontalMenuProps {
  tenant: string;
  menuItems: Data[];
}

const HorizontalMenu = ({ tenant, menuItems }: HorizontalMenuProps) => {
  const [open, setOpen] = React.useState(false);
  const [values, setValues] = React.useState<Array<string | boolean>>([]);

  function handleDrawerToggle() {
    setOpen(!open);
  }

  const handleChange = (newValue: string | boolean, level: number) => {
    const newArray = values.slice(0, level).concat(newValue);
    setValues(newArray);
  };

  return (
    <Root>
      <IconButton
        className={classes.icon}
        data-testid="sideways-megamenu-drawer-button"
        onClick={handleDrawerToggle}
        size="large"
      >
        {open ? <CloseIcon /> : <MenuIcon />}
      </IconButton>
      <Drawer
        className={classes.drawer}
        anchor="left"
        open={open}
        onClose={handleDrawerToggle}
        data-testid="sideways-megamenu-drawer-root"
        classes={{
          paper: classes.drawerList
        }}
      >
        <Toolbar className={classes.toolbar} />
        <div className={classes.columnContainer}>
          <MenuColumn
            level={0}
            data={menuItems}
            tenant={tenant}
            values={values}
            handleChange={handleChange}
            toggleMenu={handleDrawerToggle}
          />
        </div>
      </Drawer>
    </Root>
  );
};

export default HorizontalMenu;
